<script setup lang="ts">
import { SancareModal, SancareOcticon } from '@sancare/typescript-commons'
import type { CompletionOption } from '@sancare/typescript-commons/src/components/types'
import { UseMapToCompletionOptions } from '@sancare/typescript-commons/src/composables/useMapToCompletionOptions'
import type { Finess } from '@sancare/typescript-commons/src/types/finess'
import { computed } from 'vue'
import { useStore } from 'vuex'

import FinessInput from './FinessInput.vue'

interface UserAssignationProps {
  showModal: boolean
  userId: number
}

interface UserAssignationEmits {
  (e: 'close-modal'): void
}

const props = defineProps<UserAssignationProps>()
const emit = defineEmits<UserAssignationEmits>()

const store = useStore()

const editedUser = computed(() => store.getters.getUserById(props.userId))
const legalFinessList = computed<CompletionOption<Finess>[]>(() => UseMapToCompletionOptions(store.state.admin.legalFinessList, 'finess', 'shortDescription', 'finess'))
const geoFinessList = computed<CompletionOption<Finess>[]>(() => UseMapToCompletionOptions(store.state.admin.geoFinessList, 'finess', 'shortDescription', 'finess'))

const handleCloseModal = () => {
  emit('close-modal')
}
</script>

<script lang="ts">
export default {
  name: 'UserAssignationModal',
  components: {
    'sancare-modal': SancareModal,
    'sancare-octicon': SancareOcticon,
    'finess-input': FinessInput,
  },
}
</script>

<template>
  <sancare-modal
    :open="showModal"
    @close-modal="handleCloseModal"
  >
    <template #header>
      <div
        class="row"
      >
        <div class="sancare-modal-title col">
          Assignation de l'utilisateur «{{ editedUser.username }}»
        </div>
        <div
          class="sancare-modal-close col-6"
          @click="handleCloseModal"
        >
          <sancare-octicon
            name="x"
            :width="20"
            :height="20"
          />
        </div>
      </div>
    </template>

    <finess-input
      type="legal"
      :user-id="editedUser.id"
      :user-finess-list="editedUser.legalEntities"
      :completion-finess-list="legalFinessList"
    />
    <finess-input
      type="geo"
      :user-id="editedUser.id"
      :user-finess-list="editedUser.geographicEntities"
      :completion-finess-list="geoFinessList"
    />
  </sancare-modal>
</template>
